function Modal_Coral() {
  //   return (
  <div id="myModal" class="modal fade" role="dialog">
    <div class="modal-dialog">
      {/* <!-- Modal content--> */}
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
          <h4 class="modal-title">Download</h4>
        </div>
        <div class="modal-body">
          <p>Do you really want to download the file?</p>
        </div>
        <div class="modal-footer">
          {/* <!-- The download button --> */}
          <a
            href="http://s1.picswalls.com/wallpapers/2014/08/08/scottish-landscape-hd_015751702_152.jpg"
            download
          >
            <button type="button" class="btn btn-primary">
              DOWNLOAD
            </button>
          </a>
          <button type="button" class="btn btn-default" data-dismiss="modal">
            CLOSE
          </button>
        </div>
      </div>
    </div>
  </div>;
  //   );
}
export default Modal_Coral;
